import { render, staticRenderFns } from "./ProductEditStock.vue?vue&type=template&id=c196fd26&scoped=true&"
import script from "./ProductEditStock.vue?vue&type=script&lang=js&"
export * from "./ProductEditStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditStock.vue?vue&type=style&index=0&id=c196fd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c196fd26",
  null
  
)

export default component.exports